import { Injectable } from '@angular/core';

import { CountryCode } from 'libphonenumber-js';

import { LibPhonenumberService } from './lib-phone-number.service';

export interface ExamplePhoneNumber {
  countryCallingCode: string;
  nationalNumber: string;
}

@Injectable({
  providedIn: 'root',
})
export class PhoneNumberService {
  constructor(private libPhonenumberService: LibPhonenumberService) {}

  getExamplePhoneNumber(countryCode: string): ExamplePhoneNumber {
    const phoneNumber = this.libPhonenumberService.getExampleNumber(
      countryCode.toUpperCase() as CountryCode
    );
    return {
      countryCallingCode: phoneNumber.countryCallingCode,
      nationalNumber: phoneNumber.nationalNumber,
    };
  }

  getExamplePhoneNumberLength(countryCode: string): number {
    const examplePhoneNumber = this.getExamplePhoneNumber(countryCode);
    return examplePhoneNumber.nationalNumber.length;
  }

  getFullPhoneNumber(phoneNumber: string, dialCode: string, countryIsoCode: string): string {
    if (!dialCode) {
      const examplePhoneNumber = this.getExamplePhoneNumber(countryIsoCode);
      dialCode = examplePhoneNumber.countryCallingCode;
    }
    return `+${dialCode}${phoneNumber}`;
  }
}
